import { render } from "./top.vue?vue&type=template&id=70e590c0&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"

import "./top.vue?vue&type=style&index=0&id=70e590c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e590c0"]])

export default __exports__